import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Link,
  Stack,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Iconify from "../../../components/iconify";
import { usePersistentState } from "../../../contexts/global-context";
import { SetLocalStorage } from "../../../utils/local-storage";
import { isEmpty, isValidEmail } from "../../../utils/validator";
import APIS from "../../../config/api";
import { POST } from "../../../config/https";
import FullScreenLoader from "../../../components/full-screen-loader";
import ValidationError from "../../../components/validation-error-label";
import Color from "../../../theme/color";

export default function LoginForm() {
  const navigate = useNavigate();
  const [, dispatch]: any = usePersistentState();
  const [email, setEmail]: any = useState("");
  const [error, setErrors] = useState("");
  const [password, setPassword]: any = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [isValidation, setIsValidation] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showSignIn, setShowSignIn] = useState(true);
  const toggleForm = () => {
    setShowSignIn(!showSignIn);
    navigate("/signup");
  };
  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [email, password, isValidation, error]);

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      handleClick();
    }
  };

  const handleClick = async () => {
    setIsValidation(true);
    if (!password || password.trim() === "") {
      setErrors("Password cannot be null or blank.");
      validator();
      return;
    }
    let params = {
      email: email.trim(),
      password: password.trim(),
    };
    SetLocalStorage("isLogin", true);
    setLoader(true);
    await POST(APIS.LOGIN, params)
      .then(async (res: any) => {
        if (res?.isSuccess) {
          dispatch({ users: res.result });
          SetLocalStorage("loginData", res.result);
          SetLocalStorage("isLogin", true);
          navigate("/dashboard/sales-report", { replace: true });
          window.location.reload();
        } else {
          const errorMessage = res.errors[0].toString();
          setErrors(errorMessage);
          validator();
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const onClick = async () => {
    navigate("/forgotpassword", { replace: true });
  };

  const validator = () => {
    const errors: Record<string, string> = {};
    if (isEmpty(email)) {
      errors.email = "Please enter a email";
    }
    if (!isEmpty(email) && !isValidEmail(email)) {
      errors.email = "Please enter a valid email";
    }
    if (isEmpty(password)) {
      errors.password = "Please enter a password";
    } else if (error) {
      errors.password = error;
    } else {
      delete errors.password;
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return (
    <>
      <Stack spacing={2}>
        <TextField
          value={email}
          label="Email"
          InputLabelProps={{
            shrink: true,
          }}
          onKeyPress={handleKeyPress}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <ValidationError formErrors={formErrors.email} />
        <TextField
          style={{ marginBottom: "5px" }}
          label="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          type={showPassword ? "text" : "password"}
          InputLabelProps={{
            shrink: true,
          }}
          onKeyPress={handleKeyPress}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  <Iconify
                    icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <ValidationError formErrors={formErrors.password} />
      </Stack>

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ my: 2 }}
      >
        <Link
          variant="subtitle2"
          component="button"
          onClick={onClick}
          underline="hover"
          style={{ textDecoration: "none", fontSize: "15px" }}
        >
          Forgot password?
        </Link>
        <Link
          variant="subtitle2"
          component="button"
          onClick={toggleForm}
          underline="hover"
          style={{ textDecoration: "none", fontSize: "15px" }}
        >
          Sign Up
        </Link>
      </Stack>
      <LoadingButton
        fullWidth
        onClick={handleClick}
        size="large"
        type="submit"
        variant="contained"
        style={{ backgroundColor: Color.primary, fontSize: "17px" }}
      >
        Sign In
      </LoadingButton>
      <FullScreenLoader open={loader} />
    </>
  );
}
